/**
 * @module js/desLibraryPreviewService
 */
const updatethumbnail = (vmo, thumbnail) => {
    const { data, dispatch } = vmo;

    data.previewThumbnail = thumbnail;
    dispatch({ path: 'data', value: { ...data } });
};

export default {
    updatethumbnail
};
